import { useQuery } from '@tanstack/react-query';

import useGameDetails from './useGameDetails.js';
import useCustomClientRO from './useCustomClientRO.js';
import { BSC_MIN_GAS_HARDCAP } from 'const/index.js';


const defaultGasPrice = 0;

function useGasPrice() {
  const gameDetails = useGameDetails();

  const walletClientRO = useCustomClientRO();

  async function FetchGasPrice_viem() {
    if (!walletClientRO) {
      return 0;
    }
    try {
      const gasPriceWei = Number(await walletClientRO.getGasPrice());
      return gasPriceWei;
    } catch (e) {
      console.error(e);
      return 0;
    }
  }


  const { data: gasPrice } = useQuery({
    // we use "walletClientRO?.transport?.key" to determine when the public client has been replaced with the custom one
    queryKey: ['gasPrice', gameDetails.wantedChain.id, walletClientRO?.transport?.key],
    queryFn: FetchGasPrice_viem,
    placeholderData: defaultGasPrice,
    refetchInterval: 30 * 1000,
    staleTime: 30 * 1000,
    cacheTime: 4 * 60 * 60 * 1000,
  });

  return gasPrice;
};

export default useGasPrice;
